// extracted by mini-css-extract-plugin
export default {"FaqSec":"faq_FaqSec__us0dS","card":"faq_card__4G06f","cardToggle":"faq_cardToggle__wk1TE","active":"faq_active__JZR4s","cardToggleBody":"faq_cardToggleBody__gPsH1"};